<template>
  <div class="guess-name-challenge">
    <!-- Photo Display -->
    <div class="photo-container mb-6">
      <img :src="photoSrc" :alt="'Person to identify'" class="challenge-photo">
    </div>

    <!-- Fact Display -->
    <p v-if="challenge.fact" class="mb-4 text-center italic text-gray-700">
      {{ challenge.fact }}
    </p>

    <!-- Name Options -->
    <div class="options-grid">
      <button
        v-for="option in challenge.options"
        :key="option.id"
        :disabled="!!feedback"
        class="option-button"
        :class="getOptionClass(option.id)"
        @click="selectAnswer(option.id)"
      >
        {{ option.name }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  challenge: Object,
  feedback: Object
})

const emit = defineEmits(['answer'])

const selectedAnswer = ref(null)
const photoSrc = computed(() => props.challenge.photoUrl)

function selectAnswer(optionId) {
  if (selectedAnswer.value || props.feedback) return

  selectedAnswer.value = optionId
  emit('answer', optionId)
}

function getOptionClass(optionId) {
  const classes = ['name-option']

  if (props.feedback) {
    if (optionId === props.challenge.correctAnswer) {
      classes.push('correct-answer')
    } else if (optionId === selectedAnswer.value && !props.feedback.isCorrect) {
      classes.push('wrong-answer')
    } else {
      classes.push('disabled')
    }
  } else if (selectedAnswer.value === optionId) {
    classes.push('selected')
  }

  return classes
}
</script>

<style scoped>
.guess-name-challenge {
  @apply space-y-6;
}

.photo-container {
  @apply flex justify-center;
}

.challenge-photo {
  @apply w-48 h-48 rounded-full object-cover border-4 border-white shadow-lg;
}

.options-grid {
  @apply grid grid-cols-1 sm:grid-cols-2 gap-3;
}

.option-button {
  @apply p-4 rounded-lg border-2 border-gray-200 bg-white hover:border-accent hover:bg-secondary-fixed transition-all duration-200 font-medium text-center;
}

.option-button:disabled {
  @apply cursor-not-allowed;
}

.name-option.selected {
  @apply border-accent bg-secondary-fixed;
}

.name-option.correct-answer {
  @apply border-green-500 bg-green-50 text-green-700;
}

.name-option.wrong-answer {
  @apply border-red-500 bg-red-50 text-red-700;
}

.name-option.disabled {
  @apply opacity-50;
}

.feedback-section {
  @apply mt-6 text-center;
}

.feedback-message {
  @apply inline-flex items-center gap-3 px-4 py-3 rounded-lg;
}

.feedback-message.correct {
  @apply bg-green-100 text-green-800;
}

.feedback-message.incorrect {
  @apply bg-red-100 text-red-800;
}

.feedback-icon {
  @apply text-2xl font-bold;
}

.feedback-title {
  @apply font-semibold;
}

.xp-gained {
  @apply text-sm font-medium;
}
</style>
